<div class="ticket-management-container bg-light" style="height: calc(100vh - 59px); overflow: hidden; display: flex; flex-direction: column;">
  <!-- Loading State -->
  <div *ngIf="loading" class="d-flex align-items-center justify-content-center" style="height: 100%;">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading" class="d-flex flex-column h-100">
    <!-- Header -->
    <header class="bg-white border-bottom px-4 py-3">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-3 flex-grow-1">
          <h2 class="mb-0 fw-bold text-dark">Support Tickets</h2>
          <div class="position-relative flex-grow-1" style="max-width: 400px;">
            <i class="fa-solid fa-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
            <input
              type="text"
              pInputText
              name="searchQuery"
              [(ngModel)]="searchQuery"
              (input)="onSearch()"
              (keyup.enter)="onSearch()"
              placeholder="Search tickets by subject, ID, or description..."
              class="w-100 ps-5"
              style="padding-top: 0.625rem; padding-bottom: 0.625rem;"
            />
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button
            pButton
            pRipple
            type="button"
            icon="fa-solid fa-filter"
            label="Filter"
            class="p-button-outlined p-button-sm"
          ></button>
        <button
          pButton
          pRipple
          type="button"
            icon="fa-solid fa-download"
            label="Export"
            class="p-button-outlined p-button-sm"
            (click)="exportTickets()"
        ></button>
        <button
          pButton
          pRipple
          type="button"
            icon="fa-solid fa-plus"
            label="Create New Ticket"
          class="p-button-sm"
            (click)="openCreateTicketModal()"
        ></button>
        </div>
      </div>
    </header>

    <!-- Stats Section -->
    <section class="bg-white border-bottom px-4 py-3">
      <div class="row g-3">
        <div class="col">
          <div class="stats-card bg-gradient-blue rounded-3 p-3 border border-primary-subtle">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="stats-icon bg-primary rounded-2 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa-solid fa-inbox text-white"></i>
              </div>
              <span class="badge bg-primary-subtle text-primary px-2 py-1 rounded-pill small">+12%</span>
            </div>
            <p class="h4 fw-bold mb-0 text-dark">{{ stats.totalTickets }}</p>
            <p class="small text-muted mb-0">Total Tickets</p>
          </div>
        </div>
        <div class="col">
          <div class="stats-card bg-gradient-orange rounded-3 p-3 border border-warning-subtle">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="stats-icon bg-warning rounded-2 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa-solid fa-folder-open text-white"></i>
              </div>
              <span class="badge bg-warning-subtle text-warning px-2 py-1 rounded-pill small">Active</span>
            </div>
            <p class="h4 fw-bold mb-0 text-dark">{{ stats.openTickets }}</p>
            <p class="small text-muted mb-0">Open Tickets</p>
          </div>
        </div>
        <div class="col">
          <div class="stats-card bg-gradient-yellow rounded-3 p-3 border border-warning-subtle">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="stats-icon bg-warning rounded-2 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa-solid fa-clock text-white"></i>
              </div>
              <span class="badge bg-warning-subtle text-warning px-2 py-1 rounded-pill small">-5%</span>
            </div>
            <p class="h4 fw-bold mb-0 text-dark">{{ stats.inProgressTickets }}</p>
            <p class="small text-muted mb-0">In Progress</p>
          </div>
        </div>
        <div class="col">
          <div class="stats-card bg-gradient-green rounded-3 p-3 border border-success-subtle">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="stats-icon bg-success rounded-2 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa-solid fa-check-circle text-white"></i>
              </div>
              <span class="badge bg-success-subtle text-success px-2 py-1 rounded-pill small">+8%</span>
            </div>
            <p class="h4 fw-bold mb-0 text-dark">{{ stats.solvedToday }}</p>
            <p class="small text-muted mb-0">Solved Today</p>
      </div>
    </div>
        <div class="col">
          <div class="stats-card bg-gradient-purple rounded-3 p-3 border border-info-subtle">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="stats-icon bg-info rounded-2 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa-solid fa-chart-line text-white"></i>
              </div>
              <span class="badge bg-info-subtle text-info px-2 py-1 rounded-pill small">2.5h</span>
            </div>
            <p class="h4 fw-bold mb-0 text-dark">{{ stats.avgResponseTime }}</p>
            <p class="small text-muted mb-0">Avg Response</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Filters Section -->
    <section class="bg-white border-bottom px-4 py-3">
      <div class="d-flex align-items-center gap-2">
        <button
          *ngFor="let status of ['All Status', 'Open', 'In Progress', 'Solved', 'Closed']"
          [class]="activeStatusFilter === status ? 'btn btn-primary btn-sm' : 'btn btn-outline-secondary btn-sm'"
          (click)="onStatusFilterChange(status)"
        >
          {{ status }}
        </button>
        <div class="flex-grow-1"></div>
        <div class="d-flex align-items-center gap-2">
          <span class="small text-muted">Sort by:</span>
          <select
            pInputText
            name="sortBy"
            [(ngModel)]="sortBy"
            (change)="onSortChange()"
            class="form-select form-select-sm"
            style="width: auto;"
          >
            <option>Newest First</option>
            <option>Oldest First</option>
            <option>Priority: High to Low</option>
            <option>Priority: Low to High</option>
            <option>Recently Updated</option>
          </select>
        </div>
        <div class="btn-group border rounded">
          <button
            [class]="viewMode === 'list' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-secondary'"
            (click)="onViewModeChange('list')"
          >
            <i class="fa-solid fa-list"></i>
          </button>
          <button
            [class]="viewMode === 'grid' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-secondary'"
            (click)="onViewModeChange('grid')"
          >
            <i class="fa-solid fa-th"></i>
          </button>
        </div>
      </div>
    </section>

    <!-- Tickets List Section -->
    <div class="flex-grow-1 overflow-auto">
      <section class="px-4 py-4">
        <div class="bg-white rounded-3 border shadow-sm overflow-hidden">
          <p-table
            [value]="filteredTickets"
            [paginator]="true"
            [rows]="rows"
            [first]="first"
            [totalRecords]="totalRecords"
            (onPage)="onPageChange($event)"
            [responsive]="true"
            styleClass="p-datatable-sm"
            [tableStyle]="{ 'min-width': '50rem' }"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 50px;">
                  <p-checkbox
                    name="selectAll"
                    [(ngModel)]="selectAll"
                    (onChange)="onSelectAllChange($event.checked)"
                  ></p-checkbox>
                </th>
                <th>Ticket ID</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Category</th>
                <th>Created</th>
                <th>Comments</th>
                <th>Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-ticket>
              <tr class="ticket-row" (click)="openTicketDetailModal(ticket)">
                <td (click)="$event.stopPropagation()">
                  <p-checkbox
                    [ngModel]="isTicketSelected(ticket.id)"
                    (onChange)="onCheckboxChange(ticket, $event.checked)"
                  ></p-checkbox>
                </td>
                <td>
                  <span class="text-primary fw-semibold small">{{ ticket.ticketId }}</span>
                </td>
                <td>
                  <div class="d-flex align-items-start gap-2">
                    <i *ngIf="ticket.hasAttachment" class="fa-solid fa-paperclip text-muted mt-1"></i>
                    <div>
                      <p class="small fw-medium mb-1 text-dark">{{ ticket.subject }}</p>
                      <p class="small text-muted mb-0">{{ ticket.description | slice:0:50 }}...</p>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="badge" [ngClass]="getStatusClass(ticket.status)">
                    <i class="fa-solid fa-circle me-1" style="font-size: 6px;"></i>
                    {{ ticket.status }}
                  </span>
                </td>
                <td>
                  <span class="badge" [ngClass]="getPriorityClass(ticket.priority)">
                    <i class="fa-solid me-1" [ngClass]="getPriorityIcon(ticket.priority)"></i>
                    {{ ticket.priority }}
                  </span>
                </td>
                <td>
                  <span class="small text-muted">{{ ticket.category }}</span>
                </td>
                <td>
                  <div>
                    <p class="small mb-0 text-dark">{{ getTimeAgo(ticket.createdAt) }}</p>
                    <p class="small text-muted mb-0">{{ formatDate(ticket.createdAt) | date:'MMM d, y' }}</p>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa-solid fa-comment text-muted"></i>
                    <span class="small fw-medium text-dark">{{ ticket.commentCount || 0 }}</span>
                  </div>
                </td>
                <td (click)="$event.stopPropagation()">
                  <div class="d-flex align-items-center gap-2">
                    <button
                      pButton
                      pRipple
                      type="button"
                      icon="fa-solid fa-eye"
                      class="p-button-text p-button-sm text-primary"
                      (click)="openTicketDetailModal(ticket); $event.stopPropagation()"
                      pTooltip="View Details"
                    ></button>
                    <button
                      pButton
                      pRipple
                      type="button"
                      icon="fa-solid fa-edit"
                      class="p-button-text p-button-sm text-success"
                      (click)="openTicketDetailModal(ticket); $event.stopPropagation()"
                      pTooltip="Edit"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="9" class="text-center py-5">
                  <p class="text-muted">No tickets found</p>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </section>
    </div>
        </div>

  <!-- Create Ticket Modal -->
  <p-dialog
    [(visible)]="showCreateTicketModal"
    [modal]="true"
    [maximizable]="true"
    header="Create New Ticket"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeCreateTicketModal()"
  >
    <form (ngSubmit)="createTicket()">
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <label class="form-label small fw-semibold">Company Email</label>
          <div class="position-relative">
            <i class="fa-solid fa-envelope position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
            <input
              pInputText
              type="email"
              [value]="currentUser?.email"
              readonly
              class="w-100 ps-5 bg-light"
            />
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label small fw-semibold">Full Name</label>
          <div class="position-relative">
            <i class="fa-solid fa-user position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
            <input
              pInputText
              type="text"
              [value]="currentUser?.name || 'Company User'"
              readonly
              class="w-100 ps-5 bg-light"
            />
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label small fw-semibold">Category *</label>
        <p-dropdown
          name="category"
          [(ngModel)]="createTicketForm.category"
          [options]="['Bug Report', 'Feature Request', 'Support', 'Technical Issue', 'Account Management']"
          placeholder="Select a category"
          class="w-100"
          [showClear]="false"
        ></p-dropdown>
      </div>

      <div class="mb-3">
        <label class="form-label small fw-semibold">Priority Level</label>
        <div class="row g-2">
          <div class="col-3" *ngFor="let priority of ['Low', 'Normal', 'High', 'Urgent']">
            <button
              type="button"
              [class]="createTicketForm.priority === priority ? 'btn btn-outline-primary w-100 border-2' : 'btn btn-outline-secondary w-100'"
              (click)="createTicketForm.priority = priority"
            >
              <i class="fa-solid me-2" [ngClass]="getPriorityIcon(priority)"></i>
              {{ priority }}
            </button>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label small fw-semibold">Subject *</label>
        <input
          pInputText
          name="subject"
          [(ngModel)]="createTicketForm.subject"
          placeholder="Brief description of your issue"
          class="w-100"
        />
      </div>

      <div class="mb-3">
        <label class="form-label small fw-semibold">Description *</label>
            <textarea
              pInputTextarea
          name="description"
          [(ngModel)]="createTicketForm.description"
          rows="6"
          placeholder="Provide detailed information about your issue..."
              class="w-100"
            ></textarea>
        <p class="small text-muted mt-2">
          Please include as much detail as possible to help us resolve your issue quickly
        </p>
      </div>

      <div class="mb-3">
        <label class="form-label small fw-semibold">Attachments</label>
        <div
          class="border-2 border-dashed rounded p-4 text-center"
          (click)="fileInput.click()"
          style="cursor: pointer;"
        >
          <i class="fa-solid fa-cloud-upload-alt fa-2x text-muted mb-2"></i>
          <p class="small fw-medium mb-1">Drop files here or click to upload</p>
          <p class="small text-muted">Supported formats: JPG, PNG, PDF (Max 10MB)</p>
          <input
            #fileInput
            type="file"
            multiple
            (change)="onFileSelect($event)"
            class="d-none"
          />
        </div>
        <div class="mt-3" *ngIf="createTicketForm.attachments.length > 0">
          <div
            *ngFor="let file of createTicketForm.attachments; let i = index"
            class="d-flex align-items-center justify-content-between p-2 bg-light rounded mb-2 border"
          >
            <div class="d-flex align-items-center gap-2">
              <div class="bg-primary-subtle rounded p-2">
                <i class="fa-solid fa-file-pdf text-primary"></i>
              </div>
              <div>
                <p class="small fw-medium mb-0">{{ file.name }}</p>
                <p class="small text-muted mb-0">{{ (file.size / 1024 / 1024).toFixed(2) }} MB</p>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-link text-danger p-0"
              (click)="removeAttachment(i)"
            >
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between pt-3 border-top">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="emailNotification"
            name="emailNotification"
            [(ngModel)]="createTicketForm.emailNotification"
          />
          <label class="form-check-label small" for="emailNotification">
            Send me email notifications for updates
          </label>
        </div>
        <div class="d-flex gap-2">
          <button
            pButton
            pRipple
            type="button"
            label="Cancel"
            class="p-button-outlined p-button-sm"
            (click)="closeCreateTicketModal()"
            [disabled]="creatingTicket"
          ></button>
          <button
            pButton
            pRipple
            type="submit"
            [label]="creatingTicket ? 'Submitting...' : 'Submit Ticket'"
            [icon]="creatingTicket ? 'pi pi-spin pi-spinner' : 'fa-solid fa-paper-plane'"
            class="p-button-sm"
            [disabled]="creatingTicket"
          ></button>
        </div>
      </div>
    </form>
  </p-dialog>

  <!-- Ticket Detail Modal -->
  <p-dialog
    [(visible)]="showTicketDetailModal"
    [modal]="true"
    [style]="{ width: '60vw' }"
    [maximizable]="true"
    [header]="selectedTicket?.ticketId"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeTicketDetailModal()"
    [closable]="true"
  >
    <div *ngIf="selectedTicket" class="d-flex h-100">
      <!-- Main Content -->
      <div class="flex-grow-1 pe-4" style="max-height: 70vh; overflow-y: auto;">
        <!-- Ticket Header -->
        <div class="mb-4 pb-3 border-bottom">
          <div class="d-flex align-items-start justify-content-between mb-2">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center gap-2 mb-2">
                <span class="badge" [ngClass]="getStatusClass(selectedTicket.status)">
                  <i class="fa-solid fa-circle me-1" style="font-size: 6px;"></i>
                  {{ selectedTicket.status }}
                </span>
                <span class="badge" [ngClass]="getPriorityClass(selectedTicket.priority)">
                  <i class="fa-solid me-1" [ngClass]="getPriorityIcon(selectedTicket.priority)"></i>
                  {{ selectedTicket.priority }}
                </span>
              </div>
              <!-- View Mode -->
              <h3 *ngIf="!editingTicket" class="h4 fw-bold mb-2">{{ selectedTicket.subject }}</h3>
              <!-- Edit Mode -->
              <div *ngIf="editingTicket" class="mb-3">
                <label class="form-label small fw-semibold">Subject *</label>
                <input
                  pInputText
                  name="editTicketSubject"
                  [(ngModel)]="editTicketData.subject"
                  placeholder="Ticket subject"
                  class="w-100"
                />
              </div>
              <div class="d-flex align-items-center gap-3 small text-muted">
                <span><i class="fa-solid fa-user me-2"></i>{{ selectedTicket.requesterName }}</span>
                <span><i class="fa-solid fa-envelope me-2"></i>{{ selectedTicket.requesterEmail }}</span>
                <span><i class="fa-solid fa-clock me-2"></i>Created {{ getTimeAgo(selectedTicket.createdAt) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Description -->
        <div class="mb-4">
          <h6 class="small fw-semibold text-muted mb-2">Description</h6>
          <!-- View Mode -->
          <div *ngIf="!editingTicket" class="bg-light rounded p-4 border">
            <p class="text-dark mb-0" style="line-height: 1.6;">{{ selectedTicket.description }}</p>
          </div>
          <!-- Edit Mode -->
          <div *ngIf="editingTicket">
            <textarea
              pInputTextarea
              name="editTicketDescription"
              [(ngModel)]="editTicketData.description"
              rows="6"
              placeholder="Ticket description"
              class="w-100"
            ></textarea>
          </div>
        </div>

        <!-- Attachments -->
        <div class="mb-4">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="small fw-semibold text-muted mb-0">Attachments</h6>
            <button
              *ngIf="editingTicket"
              type="button"
              class="btn btn-link p-0 small text-primary"
              (click)="ticketFileInput.click()"
            >
              <i class="fa-solid fa-plus me-1"></i>Add Files
            </button>
          </div>
          <input
            #ticketFileInput
            type="file"
            multiple
            (change)="onTicketFileSelect($event)"
            class="d-none"
          />
          <!-- View Mode -->
          <div *ngIf="!editingTicket && selectedTicket.attachments && selectedTicket.attachments.length > 0" class="row g-2">
            <div class="col-md-6" *ngFor="let attachment of selectedTicket.attachments">
              <div class="d-flex align-items-center p-2 bg-light rounded border">
                <div class="bg-primary-subtle rounded p-2 me-2">
                  <i class="fa-solid fa-file-pdf text-primary"></i>
                </div>
                <div class="flex-grow-1 min-w-0">
                  <p class="small fw-medium mb-0 text-truncate">{{ getAttachmentName(attachment) }}</p>
                  <p class="small text-muted mb-0" *ngIf="getAttachmentSize(attachment)">
                    {{ getAttachmentSize(attachment) }}
                  </p>
                </div>
                <a [href]="getAttachmentUrl(attachment)" target="_blank" class="btn btn-link text-primary p-1">
                  <i class="fa-solid fa-download"></i>
                </a>
              </div>
            </div>
          </div>
          <!-- Edit Mode - Existing Attachments -->
          <div *ngIf="editingTicket && editTicketData.existingAttachments.length > 0" class="mb-3">
            <p class="small fw-semibold mb-2">Existing Attachments:</p>
            <div class="row g-2">
              <div class="col-md-6" *ngFor="let attachment of editTicketData.existingAttachments; let i = index">
                <div class="d-flex align-items-center p-2 bg-light rounded border">
                  <div class="bg-primary-subtle rounded p-2 me-2">
                    <i class="fa-solid fa-file text-primary"></i>
                  </div>
                  <div class="flex-grow-1 min-w-0">
                    <p class="small fw-medium mb-0 text-truncate">{{ getAttachmentName(attachment) }}</p>
                    <p class="small text-muted mb-0" *ngIf="getAttachmentSize(attachment)">
                      {{ getAttachmentSize(attachment) }}
                    </p>
                  </div>
                  <button
                    type="button"
                    class="btn btn-link text-danger p-1"
                    (click)="removeTicketAttachment(i)"
                    title="Remove Attachment"
                  >
                    <i class="fa-solid fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Edit Mode - New Attachments Preview -->
          <div *ngIf="editingTicket && editTicketData.attachments.length > 0" class="mb-3">
            <p class="small fw-semibold mb-2">New Attachments:</p>
            <div class="d-flex flex-column gap-2">
              <div
                *ngFor="let file of editTicketData.attachments; let i = index"
                class="d-flex align-items-center justify-content-between p-2 bg-white rounded border"
              >
                <div class="d-flex align-items-center gap-2">
                  <div class="bg-primary-subtle rounded p-2">
                    <i class="fa-solid fa-file text-primary"></i>
                  </div>
                  <div>
                    <p class="small fw-medium mb-0">{{ file.name }}</p>
                    <p class="small text-muted mb-0">{{ (file.size / 1024).toFixed(2) }} KB</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-link text-danger p-0"
                  (click)="removeNewTicketAttachment(i)"
                >
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- Empty State -->
          <div *ngIf="!editingTicket && (!selectedTicket.attachments || selectedTicket.attachments.length === 0)" class="text-muted small">
            No attachments
          </div>
        </div>

        <!-- Comments -->
        <div class="mb-4">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="small fw-semibold text-muted mb-0">Comments & Discussion</h6>
            <span class="small text-muted">{{ selectedTicket.comments?.length || 0 }} messages</span>
          </div>

          <div class="d-flex flex-column gap-3 mb-4">
            <div *ngFor="let comment of selectedTicket.comments; let commentIndex = index" class="d-flex gap-3">
              <img
                *ngIf="comment.userAvatar"
                [src]="comment.userAvatar"
                [alt]="comment.userName"
                class="rounded-circle flex-shrink-0"
                style="width: 40px; height: 40px; object-fit: cover;"
              />
              <div
                *ngIf="!comment.userAvatar"
                class="user-avatar-fallback rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                style="width: 40px; height: 40px;"
              >
                {{ (comment.userName || '?')[0] }}
              </div>
              <div class="flex-grow-1">
                <!-- View Mode -->
                <div *ngIf="editingCommentId !== getCommentIdentifier(comment)" [class]="comment.isAdmin ? 'bg-primary-subtle rounded p-3 border border-primary' : 'bg-light rounded p-3 border'">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <div class="d-flex align-items-center gap-2">
                      <span class="small fw-semibold text-dark">{{ comment.userName }}</span>
                      <span *ngIf="comment.isAdmin" class="badge bg-primary text-white small">Admin</span>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <span class="small text-muted">{{ getTimeAgo(comment.createdAt) }}</span>
                      <!-- Edit/Delete buttons - only show for comment owner -->
                      <div *ngIf="isCommentOwner(comment) && !comment.message.includes('Status updated')" class="d-flex align-items-center gap-1">
                        <button
                          type="button"
                          class="btn btn-link p-0 text-primary"
                          (click)="startEditComment(comment)"
                          title="Edit Comment"
                          [disabled]="editingCommentId !== null || deletingCommentId !== null || addingComment"
                        >
                          <i class="fa-solid fa-edit small"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-link p-0 text-danger"
                          (click)="deleteComment(comment)"
                          title="Delete Comment"
                          [disabled]="deletingCommentId === getCommentIdentifier(comment) || editingCommentId !== null || addingComment"
                        >
                          <i *ngIf="deletingCommentId !== getCommentIdentifier(comment)" class="fa-solid fa-trash small"></i>
                          <i *ngIf="deletingCommentId === getCommentIdentifier(comment)" class="pi pi-spin pi-spinner small"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <p class="small text-dark mb-0" style="line-height: 1.6;">{{ comment.message }}</p>
                  <!-- Display comment attachments -->
                  <div *ngIf="comment.attachments && comment.attachments.length > 0" class="mt-3">
                    <div class="row g-2">
                      <div class="col-md-6" *ngFor="let attachment of comment.attachments">
                        <div class="d-flex align-items-center p-2 bg-white rounded border">
                          <div class="bg-primary-subtle rounded p-2 me-2">
                            <i class="fa-solid fa-file text-primary"></i>
                          </div>
                          <div class="flex-grow-1 min-w-0">
                            <p class="small fw-medium mb-0 text-truncate">{{ getAttachmentName(attachment) }}</p>
                            <p class="small text-muted mb-0" *ngIf="getAttachmentSize(attachment)">
                              {{ getAttachmentSize(attachment) }}
                            </p>
                          </div>
                          <a [href]="getAttachmentUrl(attachment)" target="_blank" class="btn btn-link text-primary p-1">
                            <i class="fa-solid fa-download"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="comment.message.includes('Status updated')" class="mt-2">
                    <span class="small text-primary fw-medium">Status updated:</span>
                    <span class="badge ms-2" [ngClass]="getStatusClass(comment.message.split(': ')[1])">
                      {{ comment.message.split(': ')[1] }}
                    </span>
                  </div>
                </div>

                <!-- Edit Mode -->
                <div *ngIf="editingCommentId === getCommentIdentifier(comment)" class="bg-light rounded p-3 border">
                  <div class="mb-3">
                    <textarea
                      pInputTextarea
                      [(ngModel)]="editCommentMessage"
                      rows="4"
                      placeholder="Edit your comment..."
                      class="w-100"
                    ></textarea>
                  </div>

                  <!-- Existing attachments with remove option -->
                  <div *ngIf="editCommentExistingAttachments.length > 0" class="mb-3">
                    <p class="small fw-semibold mb-2">Existing Attachments:</p>
                    <div class="row g-2">
                      <div class="col-md-6" *ngFor="let attachment of editCommentExistingAttachments; let i = index">
                        <div class="d-flex align-items-center p-2 bg-white rounded border">
                          <div class="bg-primary-subtle rounded p-2 me-2">
                            <i class="fa-solid fa-file text-primary"></i>
                          </div>
                          <div class="flex-grow-1 min-w-0">
                            <p class="small fw-medium mb-0 text-truncate">{{ getAttachmentName(attachment) }}</p>
                            <p class="small text-muted mb-0" *ngIf="getAttachmentSize(attachment)">
                              {{ getAttachmentSize(attachment) }}
                            </p>
                          </div>
                          <button
                            type="button"
                            class="btn btn-link text-danger p-1"
                            (click)="removeEditCommentAttachment(i)"
                            title="Remove Attachment"
                          >
                            <i class="fa-solid fa-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- New attachments preview -->
                  <div *ngIf="editCommentAttachments.length > 0" class="mb-3">
                    <p class="small fw-semibold mb-2">New Attachments:</p>
                    <div class="d-flex flex-column gap-2">
                      <div
                        *ngFor="let file of editCommentAttachments; let i = index"
                        class="d-flex align-items-center justify-content-between p-2 bg-white rounded border"
                      >
                        <div class="d-flex align-items-center gap-2">
                          <div class="bg-primary-subtle rounded p-2">
                            <i class="fa-solid fa-file text-primary"></i>
                          </div>
                          <div>
                            <p class="small fw-medium mb-0">{{ file.name }}</p>
                            <p class="small text-muted mb-0">{{ (file.size / 1024).toFixed(2) }} KB</p>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-link text-danger p-0"
                          (click)="editCommentAttachments.splice(i, 1)"
                        >
                          <i class="fa-solid fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Add new attachments -->
                  <div class="mb-3">
                    <input
                      #editCommentFileInput
                      type="file"
                      multiple
                      (change)="onEditCommentFileSelect($event)"
                      class="d-none"
                    />
                    <button
                      type="button"
                      class="btn btn-link text-muted p-0 small"
                      (click)="editCommentFileInput.click()"
                    >
                      <i class="fa-solid fa-paperclip me-2"></i>Add attachments
                    </button>
                  </div>

                  <!-- Edit actions -->
                  <div class="d-flex justify-content-end gap-2">
                    <button
                      pButton
                      pRipple
                      type="button"
                      label="Cancel"
                      class="p-button-outlined p-button-sm"
                      (click)="cancelEditComment()"
                      [disabled]="editingComment"
                    ></button>
                    <button
                      pButton
                      pRipple
                      type="button"
                      [label]="editingComment ? 'Saving...' : 'Save'"
                      [icon]="editingComment ? 'pi pi-spin pi-spinner' : ''"
                      class="p-button-sm"
                      (click)="saveEditComment()"
                      [disabled]="editingComment"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add Comment -->
          <div class="border-top pt-3" *ngIf="!isTicketClosed()">
            <h6 class="small fw-semibold text-muted mb-3">Add Comment</h6>
            <div class="border rounded">
              <div class="border-bottom p-2 d-flex align-items-center gap-2 flex-wrap">
                <button type="button" class="btn btn-link p-1 text-muted" title="Bold">
                  <i class="fa-solid fa-bold"></i>
                </button>
                <button type="button" class="btn btn-link p-1 text-muted" title="Italic">
                  <i class="fa-solid fa-italic"></i>
                </button>
                <button type="button" class="btn btn-link p-1 text-muted" title="Underline">
                  <i class="fa-solid fa-underline"></i>
                </button>
                <div class="vr"></div>
                <button type="button" class="btn btn-link p-1 text-muted" title="Attach File" (click)="commentFileInput.click()">
                  <i class="fa-solid fa-paperclip"></i>
                </button>
                <input
                  #commentFileInput
                  type="file"
                  multiple
                  (change)="onCommentFileSelect($event)"
                  class="d-none"
                />
              </div>
              <textarea
                pInputTextarea
                name="newComment"
                [(ngModel)]="newComment"
                rows="4"
                placeholder="Type your comment here..."
                class="w-100 border-0 p-3"
                style="resize: none;"
              ></textarea>
              <!-- Preview attached files -->
              <div class="px-3 py-2 border-top" *ngIf="commentAttachments.length > 0">
                <div class="d-flex flex-column gap-2">
                  <div
                    *ngFor="let file of commentAttachments; let i = index"
                    class="d-flex align-items-center justify-content-between p-2 bg-light rounded border"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <div class="bg-primary-subtle rounded p-2">
                        <i class="fa-solid fa-file text-primary"></i>
                      </div>
                      <div>
                        <p class="small fw-medium mb-0">{{ file.name }}</p>
                        <p class="small text-muted mb-0">{{ (file.size / 1024).toFixed(2) }} KB</p>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-link text-danger p-0"
                      (click)="removeCommentAttachment(i)"
                    >
                      <i class="fa-solid fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="border-top p-3 bg-light d-flex align-items-center justify-content-between">
                <button
                  type="button"
                  class="btn btn-link text-muted p-0 small"
                  (click)="commentFileInput.click()"
                >
                  <i class="fa-solid fa-paperclip me-2"></i>Attach files
                </button>
                <button
                  pButton
                  pRipple
                  type="button"
                  [label]="addingComment ? 'Sending...' : 'Send Comment'"
                  [icon]="addingComment ? 'pi pi-spin pi-spinner' : 'fa-solid fa-paper-plane'"
                  class="p-button-sm"
                  (click)="addComment()"
                  [disabled]="addingComment"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="border-start ps-4" style="width: 320px; max-height: 70vh; overflow-y: auto;">
        <h6 class="small fw-semibold text-dark mb-3">Ticket Details</h6>

        <div class="d-flex flex-column gap-3">
          <div>
            <label class="form-label small fw-semibold text-uppercase text-muted">Status</label>
            <p-dropdown
              *ngIf="!isTicketClosed()"
              name="editStatus"
              [(ngModel)]="editTicketForm.status"
              [options]="['Open', 'In Progress', 'Solved', 'Closed']"
              class="w-100"
            ></p-dropdown>
            <div *ngIf="isTicketClosed()" class="p-2 bg-light rounded border">
              <span class="small fw-medium">{{ selectedTicket.status }}</span>
            </div>
          </div>

          <div>
            <label class="form-label small fw-semibold text-uppercase text-muted">Priority</label>
            <p-dropdown
              *ngIf="!isTicketClosed()"
              name="editPriority"
              [(ngModel)]="editTicketForm.priority"
              [options]="['Low', 'Normal', 'High', 'Urgent']"
              class="w-100"
            ></p-dropdown>
            <div *ngIf="isTicketClosed()" class="p-2 bg-light rounded border">
              <span class="small fw-medium">{{ selectedTicket.priority }}</span>
            </div>
          </div>

          <div>
            <label class="form-label small fw-semibold text-uppercase text-muted">Category</label>
            <p-dropdown
              *ngIf="!isTicketClosed()"
              name="editCategory"
              [(ngModel)]="editTicketForm.category"
              [options]="['Bug Report', 'Feature Request', 'Support', 'Technical Issue', 'Account Management']"
              class="w-100"
            ></p-dropdown>
            <div *ngIf="isTicketClosed()" class="p-2 bg-light rounded border">
              <span class="small fw-medium">{{ selectedTicket.category }}</span>
            </div>
          </div>

          <div class="pt-3 border-top">
            <label class="form-label small fw-semibold text-uppercase text-muted">Requester</label>
            <div class="d-flex align-items-center gap-2 p-2 bg-white rounded border">
              <img
                *ngIf="selectedTicket.requesterAvatar"
                [src]="selectedTicket.requesterAvatar"
                [alt]="selectedTicket.requesterName"
                class="rounded-circle"
                style="width: 40px; height: 40px; object-fit: cover;"
              />
              <div
                *ngIf="!selectedTicket.requesterAvatar"
                class="user-avatar-fallback rounded-circle d-flex align-items-center justify-content-center"
                style="width: 40px; height: 40px;"
              >
                {{ (selectedTicket.requesterName || '?')[0] }}
              </div>
              <div>
                <p class="small fw-medium mb-0">{{ selectedTicket.requesterName }}</p>
                <p class="small text-muted mb-0">Company Manager</p>
              </div>
            </div>
          </div>

          <div>
            <label class="form-label small fw-semibold text-uppercase text-muted">Timeline</label>
            <div class="d-flex flex-column gap-2">
              <div class="d-flex align-items-start gap-2">
                <div class="bg-primary rounded-circle mt-1" style="width: 8px; height: 8px;"></div>
                <div>
                  <p class="small fw-medium mb-0">Ticket Created</p>
                  <p class="small text-muted mb-0">{{ getTimeAgo(selectedTicket.createdAt) }}</p>
                </div>
              </div>
              <div class="d-flex align-items-start gap-2" *ngIf="selectedTicket.updatedAt && selectedTicket.updatedAt !== selectedTicket.createdAt">
                <div class="bg-warning rounded-circle mt-1" style="width: 8px; height: 8px;"></div>
                <div>
                  <p class="small fw-medium mb-0">Last Updated</p>
                  <p class="small text-muted mb-0">{{ getTimeAgo(selectedTicket.updatedAt) }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="pt-3 border-top" *ngIf="!isTicketClosed()">
            <!-- View Mode: Show Save Changes and Edit Ticket buttons -->
            <button
              *ngIf="!editingTicket"
              pButton
              pRipple
              type="button"
              [label]="updatingTicket ? 'Saving...' : 'Save Changes'"
              [icon]="updatingTicket ? 'pi pi-spin pi-spinner' : 'fa-solid fa-save'"
              class="p-button-sm w-100 mb-2"
              (click)="updateTicketDetails()"
              [disabled]="updatingTicket"
            ></button>
            <button
              *ngIf="!editingTicket"
              pButton
              pRipple
              type="button"
              label="Edit Ticket"
              icon="fa-solid fa-edit"
              class="p-button-outlined p-button-sm w-100"
              (click)="startEditTicket()"
            ></button>
            <!-- Edit Mode: Show Cancel and Save Ticket buttons -->
            <button
              *ngIf="editingTicket"
              pButton
              pRipple
              type="button"
              label="Cancel"
              class="p-button-outlined p-button-sm w-100 mb-2"
              (click)="cancelEditTicket()"
              [disabled]="updatingTicket"
            ></button>
            <button
              *ngIf="editingTicket"
              pButton
              pRipple
              type="button"
              [label]="updatingTicket ? 'Saving...' : 'Save Changes'"
              [icon]="updatingTicket ? 'pi pi-spin pi-spinner' : 'fa-solid fa-save'"
              class="p-button-sm w-100"
              (click)="saveEditTicket()"
              [disabled]="updatingTicket"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</div>

<p-toast></p-toast>
